
import PRODUCTION from './config.production.js';
import STAGING from './config.staging.js';
import DEV from './config.dev.js';

const env = process.env.REACT_APP_ENV;

let config = DEV;

if( env === 'production' ) {
  config = PRODUCTION;
} else if( env === 'staging' ) {
  config = STAGING;
}

export default config;


// WEBPACK FOOTER //
// ./src/config.js